/**
 * Copied from https://github.com/mantinedev/mantine/blob/33f51e1a7e755ef189d3e87ce17bd9d78a8a0742/src/mantine-core/src/FocusTrap/FocusTrap.tsx
 * to replace the `useFocusTrap()` implementation with one that properly handles shift + tab back to RadioGroups.
 * See: https://github.com/mantinedev/mantine/issues/4678
 */

import React, { cloneElement } from "react"
import { isElement } from "@mantine/utils"
import { useMergedRef } from "@mantine/hooks"

import { useFocusTrap } from "@/hooks"

export interface FocusTrapProps {
    /** Element at which focus should be trapped, should support ref prop */
    children: any

    /** Determines whether focus should be trapped within child element */
    active?: boolean

    /** Prop that should be used to access component ref */
    refProp?: string
}

export function FocusTrap({ children, active = true, refProp = "ref" }: FocusTrapProps): React.ReactElement {
    const focusTrapRef = useFocusTrap(active)
    const ref = useMergedRef(focusTrapRef, children?.ref)

    if (!isElement(children)) {
        return children
    }

    return cloneElement(children, { [refProp]: ref })
}

FocusTrap.displayName = "FocusTrap"
